import { Component, DestroyRef, HostListener, inject, Injector, OnInit, Signal } from '@angular/core';
import { MapModeStateService } from './map-mode-state.service';
import { QPointMapModeConfiguration } from './mode';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MapModeIconPipe } from './map-mode-icon.pipe';
import { QPointIconModule } from '@qpoint/icons';

@Component({
    selector: "qpoint-map-mode-selection",
    templateUrl: "./map-mode-selection.component.html",
    styleUrls: ["./map-mode-selection.component.scss"],
    imports: [CommonModule, MapModeIconPipe, QPointIconModule]
})
export class MapModeSelectionComponent {
  public modes: QPointMapModeConfiguration[];
  private destroyRef = inject(DestroyRef);

  @HostListener("context", ["$event"])
  handleContextMenu(event: PointerEvent) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

  constructor(
    private mapModeState: MapModeStateService
  ) {
    toObservable(this.mapModeState.modesSignal)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((modes) => {
        this.modes = modes;
      });
  }

  toggleModeActive(config: QPointMapModeConfiguration) {
    this.mapModeState.updateModeActive(
      config.mode,
      !config.active,
      config.scope
    );
  }
}
